import Select, { SelectProps } from 'antd/lib/select';
import Space from 'antd/lib/space';
import Typography from 'antd/lib/typography';
import { useEffect, useMemo, useState } from 'react';
import { useVendorListQuery } from '../../../domain/vendor/queries';
import orderBy from 'lodash/orderBy';
import { IVendor } from '../../../domain/vendor/interface';

interface IOption {
    value: string;
    label: string;
    desc: string;
    disabled: boolean;
}

export const VendorSelector = (props: SelectProps) => {
    const [selectOptions, setSelectOptions] = useState<IOption[]>([]);

    const { data, error, isError, isLoading } = useVendorListQuery({
        pagination: { pageSize: 10000, current: 1 },
        include: 'company',
    });
    const vendors = useMemo(() => data?.data || [], [data]);

    useEffect(() => {
        const sortedVendors = orderBy(
            vendors,
            [
                (vendor: IVendor) => !!vendor.company_id, // sort by attached company
                (vendor: IVendor) => vendor.name, // then by vendor name
            ],
            ['asc', 'asc']
        );

        setSelectOptions(sortedVendors.map(vendor => toSelectOption(vendor)));
    }, [vendors]);

    return (
        <div>
            <Select
                size="large"
                placeholder="Select Vendor"
                autoClearSearchValue
                allowClear
                showSearch
                loading={isLoading}
                options={selectOptions}
                filterOption={(inputValue, option) => filterSelectorOption(inputValue, option as IOption)}
                optionRender={option => (
                    <Space>
                        <div>
                            <div>{option.data.label}</div>
                            <Typography.Text type="secondary">{option.data.desc}</Typography.Text>
                        </div>
                    </Space>
                )}
                {...props}
            />
        </div>
    );
};

function filterSelectorOption(inputValue: string, option: IOption | undefined) {
    const label = option?.label?.toString().toLowerCase() ?? '';
    return label.includes(inputValue.toLowerCase());
}

function toSelectOption(vendor: IVendor): IOption {
    return {
        value: vendor.id,
        label: vendor.name,
        desc: vendor.company_id ? `Linked to: ${vendor.company?.company_name}` : '',
        disabled: !!vendor.company_id,
    };
}
